<template>
    <b-modal size="xl" @hide="onHide" ref="mdlGestioneAppuntamento" title="Gestione Appuntamento"
        @shown="onShownGestioneAppuntamento" centered scrollable>
        <!-- riepilogo prestazione -->
        <div class="ft-ga-riepilogo">
            <span class="ft-ga-riepilogo-icon"><b-icon icon="calendar2-week"></b-icon></span>
            <div class="ft-ga-riepilogo-testo">
                <div class="ft-ga-riepilogo-titolo">
                    {{ appuntamentoSelRow.descrizionePrestazione }}
                    <span class="ft-ga-codice" v-if="appuntamentoSelRow.codicePrestazione">{{
                        appuntamentoSelRow.codicePrestazione }}</span>
                    <!-- riferimento ricetta -->
                    <span class="ft-ga-ricetta" v-if="riferimentoRicetta" :title="'Ricetta ' + riferimentoRicetta">
                        <b-icon icon="file-earmark-medical"></b-icon>
                        <span class="ft-ga-ricetta-label">{{ appuntamentoSelRow.codiceBar1 == 'PVT' ? 'PVT' : 'NRE'
                            }}</span>
                        {{ riferimentoRicetta }}
                    </span>
                    <span class="ft-ga-ricetta-tipo" v-if="appuntamentoSelRow.tipologiaRicetta">{{
                        appuntamentoSelRow.tipologiaRicetta }}</span>
                </div>
                <div class="ft-ga-riepilogo-sub" v-if="appuntamentoSelRow.identificativoAppuntamento">
                    <b-icon icon="person"></b-icon> {{ appuntamentoSelRow.identificativoAppuntamento }}
                </div>
            </div>
            <div class="ft-pallini">
                <div class="ft-pallino-box">
                    <label>Eseguiti</label>
                    <span class="ft-pallino ft-pallino-eseguiti">{{ contatori.eseguiti }}</span>
                </div>
                <div class="ft-pallino-box">
                    <label>Prenotati</label>
                    <span class="ft-pallino ft-pallino-prenotati">{{ contatori.prenotati }}</span>
                </div>
                <div class="ft-pallino-box">
                    <label>Ciclo</label>
                    <span class="ft-pallino ft-pallino-ciclo">{{ contatori.ciclo }}</span>
                </div>
            </div>
            <div class="ft-ga-step" v-if="isAgendaEnable">
                <span :class="['ft-ga-step-item', { 'is-active': tabSpostaAppuntamento == 1 }]">1 Seleziona</span>
                <b-icon icon="chevron-right" class="ft-ga-step-sep"></b-icon>
                <span :class="['ft-ga-step-item', { 'is-active': tabSpostaAppuntamento == 2 }]">2 Conferma</span>
            </div>
        </div>

        <template v-if="tabSpostaAppuntamento == 1">
            <b-row>
                <!-- appuntamenti della prestazione -->
                <b-col v-if="isAgendaEnable" cols="12" lg="5" class="mb-3">
                    <div class="ft-ga-sezione">
                        <div class="ft-ga-sezione-titolo">Appuntamento da spostare</div>
                        <div class="b-table-sticky-header ft-ga-tabella">
                            <b-table selectable sticky-header ref="table" striped hover small
                                :items="prestazioneSelezionata.appuntament" select-mode="single"
                                :fields="fieldAppuntamenti" sort-by="numeroOrdine" @row-selected="setRowSelected"
                                head-variant="light" class="sa-b-table" show-empty empty-text="Nessun appuntamento">
                                <template #cell(numeroOrdine)="row">
                                    <span class="ft-ga-numero">{{ row.item.numeroOrdine }}</span>
                                </template>
                                <template #cell(riferimento)="row">
                                    <div class="ft-ga-data">{{ formattaData(row.item.dataRiferimento) }}
                                        <small>{{ getGiornoSettimana(row.item.dataRiferimento) }}</small>
                                    </div>
                                    <div class="ft-ga-ora">{{ getFasciaOraria(row.item.dataOraInizio, row.item.dataOraFine) }}</div>
                                    <div class="ft-ga-agenda" :class="{ 'is-vuota': !getAgendaAppuntamento(row.item) }">
                                        <b-icon icon="journal-medical"></b-icon> {{ getAgendaAppuntamento(row.item) || "Agenda non assegnata" }}
                                    </div>
                                </template>
                                <template #cell(statoAttuale)="row">
                                    <span class="ft-ga-stato">{{ row.item.statoAttuale }}</span>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </b-col>

                <!-- nuova disponibilità -->
                <b-col cols="12" :lg="isAgendaEnable ? 7 : 12" class="mb-3">
                    <div class="ft-ga-sezione">
                        <div class="ft-ga-sezione-titolo">Nuova disponibilità</div>
                        <b-row>
                            <b-col cols="12" md="6">
                                <label class="sa-label-data">Agenda</label>
                                <b-form-select v-model="spostaAppuntamentoJsonData.idAgenda" :options="agendaOptions"
                                    @change="onChangeAgendaAppuntamento" value-field="id" text-field="titolo"
                                    :disabled="!isAppuntamentoSelezionato">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col cols="12" md="6">
                                <label class="sa-label-data">Data</label>
                                <date-picker v-model="dataRiferimentoDate" format="DD-MM-YYYY" value-type="timestamp"
                                    placeholder="Seleziona Data" type="date" class="w-100"
                                    :disabled="!isAppuntamentoSelezionato"></date-picker>
                            </b-col>
                        </b-row>

                        <div class="ft-ga-slots">
                            <button v-for="(slot, i) in slotDisponibili" :key="i" type="button"
                                :class="['ft-ga-slot', { 'is-selected': slot === nuovaDisponibilitaSelezionata }]"
                                @click="onClickSlot(slot)">
                                <span class="ft-ga-slot-ora">{{ getFasciaSlot(slot) }}</span>
                                <small>{{ formattaData(slot.dataRiferimento) }}</small>
                            </button>
                            <div v-if="slotDisponibili.length == 0" class="ft-ga-vuoto">
                                {{ isAppuntamentoSelezionato ? "Nessuno slot disponibile per agenda e data selezionate"
                                    : "Seleziona prima l'appuntamento da spostare" }}
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <!-- confronto vecchio / nuovo -->
            <div class="ft-ga-confronto" v-if="isAppuntamentoSelezionato">
                <div class="ft-ga-box">
                    <div class="ft-ga-box-titolo">Attuale</div>
                    <div class="ft-ga-data">{{ formattaData(appuntamentoSelezionatoDaSpostare.dataRiferimento) }}
                        <small>{{ getGiornoSettimana(appuntamentoSelezionatoDaSpostare.dataRiferimento) }}</small>
                    </div>
                    <div class="ft-ga-ora">{{ getFasciaOraria(appuntamentoSelezionatoDaSpostare.dataOraInizio,
                        appuntamentoSelezionatoDaSpostare.dataOraFine) }}</div>
                    <div class="ft-ga-agenda" :class="{ 'is-vuota': !getAgendaAppuntamento(appuntamentoSelezionatoDaSpostare) }">
                        <b-icon icon="journal-medical"></b-icon> {{ getAgendaAppuntamento(appuntamentoSelezionatoDaSpostare) || "Agenda non assegnata" }}
                    </div>
                    <div class="ft-ga-info">Accesso n° {{ appuntamentoSelezionatoDaSpostare.numeroOrdine }}</div>
                </div>
                <b-icon icon="arrow-right" class="ft-ga-freccia"></b-icon>
                <div :class="['ft-ga-box', { 'ft-ga-box-nuovo': nuovaDisponibilitaSelezionata }]">
                    <div class="ft-ga-box-titolo">Nuovo</div>
                    <template v-if="nuovaDisponibilitaSelezionata">
                        <div class="ft-ga-data">{{ formattaData(spostaAppuntamentoJsonData.dataRiferimento) }}
                            <small>{{ getGiornoSettimana(spostaAppuntamentoJsonData.dataRiferimento) }}</small>
                        </div>
                        <div class="ft-ga-ora">{{ getFasciaOraria(spostaAppuntamentoJsonData.dataOraInizio,
                            spostaAppuntamentoJsonData.dataOraFine) }}</div>
                        <div class="ft-ga-agenda" :class="{ 'is-vuota': !getAgendaAppuntamento(spostaAppuntamentoJsonData) }">
                            <b-icon icon="journal-medical"></b-icon> {{ getAgendaAppuntamento(spostaAppuntamentoJsonData) || "Agenda non assegnata" }}
                        </div>
                        <div class="ft-ga-info" v-if="spostaAppuntamentoJsonData.numeroOrdine">Accesso n° {{
                            spostaAppuntamentoJsonData.numeroOrdine }}</div>
                    </template>
                    <div v-else class="ft-ga-vuoto">Seleziona uno slot</div>
                </div>
            </div>
        </template>

        <!-- riepilogo nuovo schema -->
        <template v-if="tabSpostaAppuntamento == 2">
            <div class="ft-ga-sezione">
                <div class="ft-ga-sezione-titolo">Nuovo schema appuntamenti</div>
                <div class="b-table-sticky-header ft-ga-tabella ft-ga-tabella-alta">
                    <b-table sticky-header striped hover small :items="appuntamentiTmpConferma"
                        :fields="fieldAppuntamenti" :tbody-tr-class="classeRigaSpostata" head-variant="light"
                        class="sa-b-table">
                        <template #cell(numeroOrdine)="row">
                            <span class="ft-ga-numero">{{ row.item.numeroOrdine }}</span>
                        </template>
                        <template #cell(riferimento)="row">
                            <div class="ft-ga-data">{{ formattaData(row.item.dataRiferimento) }}
                                <small>{{ getGiornoSettimana(row.item.dataRiferimento) }}</small>
                            </div>
                            <div class="ft-ga-ora">{{ getFasciaOraria(row.item.dataOraInizio, row.item.dataOraFine) }}</div>
                            <div class="ft-ga-agenda" :class="{ 'is-vuota': !getAgendaAppuntamento(row.item) }">
                                <b-icon icon="journal-medical"></b-icon> {{ getAgendaAppuntamento(row.item) || "Agenda non assegnata" }}
                            </div>
                        </template>
                        <template #cell(statoAttuale)="row">
                            <span class="ft-ga-stato">{{ row.item.statoAttuale }}</span>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>

        <template #modal-footer>
            <div class="d-flex justify-content-end w-100" style="gap: 6px">
                <b-button variant="secondary" v-if="tabSpostaAppuntamento == 1"
                    @click="onAnnullaSpostaAppuntamento">Annulla</b-button>
                <b-button variant="secondary" v-if="tabSpostaAppuntamento == 2"
                    @click="tabSpostaAppuntamento = 1">Indietro</b-button>

                <b-button variant="primary" v-if="tabSpostaAppuntamento == 1 && isAgendaEnable"
                    :disabled="!nuovaDisponibilitaSelezionata" @click="tabSpostaAppuntamento = 2">
                    Avanti <b-icon icon="chevron-right"></b-icon>
                </b-button>
                <b-button variant="success" v-if="tabSpostaAppuntamento == 1 && !isAgendaEnable"
                    :disabled="!nuovaDisponibilitaSelezionata" @click="onConfermaAppuntamentoSingle">
                    <b-icon icon="check2"></b-icon> Conferma Appuntamento
                </b-button>
                <b-button variant="success" v-if="tabSpostaAppuntamento == 2" @click="onClickSpostaAppuntamento">
                    <b-icon icon="check2"></b-icon> Sposta Appuntamento
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast.js";
import axios from "axios";
export default {
    name: "GestioneAppuntamentoModalComponent",
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { DatePicker },
    data() {
        return {
            presidio: {},
            pathResourceAgendaDisponibilita: "/agendadisponibilita",
            dataRiferimentoDate: null,
            dataRiferimento: null,
            appuntamentiTmpConferma: [],

            tabSpostaAppuntamento: 1,
            disponibilitaAgendaItems: [{ disponibilita: [] }],
            appuntamentoSelezionatoDaSpostare: {},
            spostaAppuntamentoJsonData: {
                idAgenda: null,
            },
            appuntamentoSelRow: {
                statoAttuale: ""
            },
            indexRicettaSel: null,
            prestazioneSelezionata: {
                appuntament: []
            },
            isAgendaEnable: true,
            agendaOptions: [],
            nuovaDisponibilitaSelezionata: null,
            fieldAppuntamenti: [
                {
                    label: "N°",
                    key: "numeroOrdine",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Data / Ora",
                    key: "riferimento",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                },
            ],
        };
    },
    computed: {
        // NRE della ricetta (per le private PVT solo il codice, come nella lista)
        riferimentoRicetta() {
            const { codiceBar1, codiceBar2 } = this.appuntamentoSelRow;
            if (!codiceBar1 && !codiceBar2) return null;
            if (codiceBar1 == "PVT") return codiceBar2 ? String(codiceBar2).toUpperCase() : null;
            return [codiceBar1, codiceBar2].filter(Boolean).join(" ");
        },
        // pallini eseguiti / prenotati / ciclo della prestazione
        contatori() {
            const appuntamenti = this.prestazioneSelezionata.appuntament || [];
            const conta = (stato) => appuntamenti.filter((app) => app.statoAttuale === stato).length;
            const ciclo = this.prestazioneSelezionata.quantitaErogabile ?? this.appuntamentoSelRow.quantitaErogabile;
            return {
                eseguiti: conta("ESEGUITO"),
                prenotati: conta("PRENOTATO"),
                ciclo: ciclo ?? "--",
            };
        },
        slotDisponibili() {
            const giorno = this.disponibilitaAgendaItems && this.disponibilitaAgendaItems[0];
            return (giorno && giorno.disponibilita) || [];
        },
        isAppuntamentoSelezionato() {
            return !!this.appuntamentoSelezionatoDaSpostare && Object.keys(this.appuntamentoSelezionatoDaSpostare).length > 0;
        },
    },
    watch: {
        dataRiferimentoDate: function (params) {
            this.dataRiferimento = moment(params).format("YYYY-MM-DD");
        },
        dataRiferimento: function (params) {
            if (params) {
                this.loadAgendaDisponibilita();
            }
        },
    },
    mounted() {
        let tmpPresidio = window.localStorage.getItem("presidio");
        if (tmpPresidio && tmpPresidio != "null") {
            this.presidio = JSON.parse(tmpPresidio);
            this.loadAgende();
        }
    },
    methods: {
        showSingleAppuntamento(row, agende, appuntametno, indexRicetta) {
            this.appuntamentoSelRow = row;
            this.indexRicettaSel = indexRicetta;
            if (agende != null) {
                this.agendaOptions = agende;
            }
            this.appuntamentoSelezionatoDaSpostare = appuntametno;
            this.spostaAppuntamentoJsonData.idAgenda = appuntametno.idAgenda
            this.isAgendaEnable = false;
            this.$refs.mdlGestioneAppuntamento.show();
        },
        onChangeAgendaAppuntamento() {
            this.disponibilitaAgendaItems = [{ disponibilita: [] }];
            if (JSON.stringify(this.appuntamentoSelezionatoDaSpostare) == "{}") {
                toast.warning("Selezionare Appuntamento prima di seleziona agenda !")
                return;

            }
            this.loadAgendaDisponibilita();

        },
        show(row) {
            this.appuntamentoSelRow = row;

            this.$refs.mdlGestioneAppuntamento.show();
        },
        hide() {
            this.isAgendaEnable = true;
            this.$refs.mdlGestioneAppuntamento.hide();
        },
        onHide() {
            this.isAgendaEnable = true;
            this.tabSpostaAppuntamento = 1;
            this.appuntamentoSelezionatoDaSpostare = {};
            this.nuovaDisponibilitaSelezionata = null;
            this.appuntamentiTmpConferma = [];
            this.prestazioneSelezionata = { appuntament: [] };
            this.dataRiferimentoDate = null;
            this.disponibilitaAgendaItems = [{ disponibilita: [] }];
            if (this.$refs.table) this.$refs.table.clearSelected();
        },
        onAnnullaSpostaAppuntamento() {
            this.hide();
        },
        onShownGestioneAppuntamento() {
            let idPrestazione = this.appuntamentoSelRow.idPrestazione;
            if (!idPrestazione) {
                return;
            }
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioni/" + idPrestazione;
            axios
                .get(link)
                .then((response) => {
                    this.prestazioneSelezionata = response.data.data;
                    this.closeShowModalLoading();
                    this.loadAgendaDisponibilita();
                })
                .catch((e) => {
                    this.closeShowModalLoading();
                    toast.error(e?.response?.data?.messaggio);
                });
        },
        loadAgende() {
            let link = process.env.VUE_APP_PATH_API + "/agende";
            axios
                .get(link, { params: { idPresidio: this.presidio.idPresidio } })
                .then((response) => {
                    this.agendaOptions = response.data.data.list;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getOrario(data) {
            return moment(data).format("HH:mm");
        },
        // "09:00 - 09:30", oppure solo "09:00" se inizio e fine coincidono
        getFasciaOraria(inizio, fine) {
            const oraInizio = this.getOrario(inizio);
            const oraFine = this.getOrario(fine);
            return !fine || oraInizio === oraFine ? oraInizio : oraInizio + " - " + oraFine;
        },
        // titolo dell'agenda di un appuntamento: dalle agende caricate, altrimenti dal titolo dell'appuntamento
        getAgendaAppuntamento(appuntamento) {
            if (!appuntamento) return null;
            const agenda = appuntamento.idAgenda ? this.agendaOptions.find((a) => a.id == appuntamento.idAgenda) : null;
            if (agenda) return agenda.titolo;
            return appuntamento.titolo && appuntamento.titolo != "ACCESSI" ? appuntamento.titolo : null;
        },
        getFasciaSlot(slot) {
            return !slot.alleOre || slot.dalleOre === slot.alleOre ? slot.dalleOre : slot.dalleOre + " - " + slot.alleOre;
        },
        onClickSlot(slot) {
            // un secondo click sullo slot già scelto lo deseleziona
            this.onDisponibilitaSelected(slot === this.nuovaDisponibilitaSelezionata ? [] : [slot]);
        },
        classeRigaSpostata(item, type) {
            if (type !== "row" || !item) return "";
            return item.id === this.appuntamentoSelezionatoDaSpostare.id ? "ft-ga-riga-spostata" : "";
        },
        formattaData(dataString) {
            if (!dataString) return '--';
            const parti = dataString.split('-');
            return `${parti[2]}/${parti[1]}/${parti[0]} `;
        },
        getGiornoSettimana(dataString) {
            if (!dataString) return '--';
            const giornoSettimana = moment(dataString).locale('it').format('dddd');
            return giornoSettimana;
        },
        setRowSelected(item) {
            if (item && item.length > 0) {
                let app = item[0];
                if (app.statoAttuale == "ESEGUITO" || app.statoAttuale == "NON ESEGUITO") {
                    this.appuntamentoSelezionatoDaSpostare = {};
                    toast.warning("Appuntamento già marcato come " + app.statoAttuale + " , non è possibile spostare!");
                    this.$refs.table.clearSelected();
                    return;
                }
                this.appuntamentoSelezionatoDaSpostare = app;
                this.nuovaDisponibilitaSelezionata = null;
                this.spostaAppuntamentoJsonData = JSON.parse(JSON.stringify(app));
                this.dataRiferimentoDate = new Date().getTime();
            } else {
                this.appuntamentoSelezionatoDaSpostare = {};
            }
        },
        convertiInTimestamp(data, ora) {
            const dateFinal = `${data}T${ora}:00`;
            return new Date(dateFinal).getTime();
        },
        onDisponibilitaSelected(items) {
            if (items && items.length > 0) {
                this.nuovaDisponibilitaSelezionata = items[0];
                this.spostaAppuntamentoJsonData.dataRiferimento = this.nuovaDisponibilitaSelezionata.dataRiferimento
                this.spostaAppuntamentoJsonData.alleOre = this.nuovaDisponibilitaSelezionata.alleOre
                this.spostaAppuntamentoJsonData.dalleOre = this.nuovaDisponibilitaSelezionata.dalleOre
                this.spostaAppuntamentoJsonData.dataOraFine = this.convertiInTimestamp(this.nuovaDisponibilitaSelezionata.dataRiferimento, this.nuovaDisponibilitaSelezionata.alleOre)
                this.spostaAppuntamentoJsonData.dataOraInizio = this.convertiInTimestamp(this.nuovaDisponibilitaSelezionata.dataRiferimento, this.nuovaDisponibilitaSelezionata.dalleOre)
                this.spostaAppuntamentoJsonData.costo = this.appuntamentoSelRow.costo;
                this.spostaAppuntamentoJsonData.codiceBar1 = this.appuntamentoSelRow.codiceBar1;
                this.spostaAppuntamentoJsonData.codiceBar2 = this.appuntamentoSelRow.codiceBar2;
                this.spostaAppuntamentoJsonData.quantitaErogabile = this.appuntamentoSelRow.quantitaErogabile

                let appuntamentiTmp = JSON.parse(JSON.stringify(this.prestazioneSelezionata.appuntament));

                const index = appuntamentiTmp.findIndex(app => app.id === this.appuntamentoSelezionatoDaSpostare.id);

                if (index !== -1) {
                    appuntamentiTmp[index] = JSON.parse(JSON.stringify(this.spostaAppuntamentoJsonData));
                }
                appuntamentiTmp.sort((a, b) => a.dataOraInizio - b.dataOraInizio);
                appuntamentiTmp = appuntamentiTmp.map((app, idx) => {
                    const nuovoOrdine = idx + 1;
                    if (app.id == this.appuntamentoSelezionatoDaSpostare.id) {
                        this.spostaAppuntamentoJsonData.numeroOrdine = nuovoOrdine;
                    }
                    app.numeroOrdine = nuovoOrdine;
                    return app;
                });
                this.appuntamentiTmpConferma = appuntamentiTmp;
            } else {
                this.nuovaDisponibilitaSelezionata = null;
            }
        },
        loadAgendaDisponibilita() {
            if (JSON.stringify(this.appuntamentoSelezionatoDaSpostare) != "{}") {
                let itemFIlter = {
                    language: "it",
                    idAgenda: this.spostaAppuntamentoJsonData.idAgenda,
                    periodo: "G",
                    riferimento: this.dataRiferimento,
                    codicePrestazione: this.appuntamentoSelezionatoDaSpostare.codicePrestazione,
                };
                this.disponibilitaAgendaItems = [{ disponibilita: [] }];
                this.openShowModalLoading();
                this.loadDataResources(this.pathResourceAgendaDisponibilita, itemFIlter, this.loadAgendaDisponibilitaSuccess, this.loadAgendaDisponibilitaError);
            }
        },
        loadAgendaDisponibilitaSuccess(response) {
            this.disponibilitaAgendaItems = response.data.data;
            this.closeShowModalLoading();
        },
        loadAgendaDisponibilitaError(error) {
            console.log(error);
            this.closeShowModalLoading();
        },
        onClickSpostaAppuntamento() {
            this.openShowModalLoading()
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/sposta/" + this.spostaAppuntamentoJsonData.id;
            axios.put(link, this.spostaAppuntamentoJsonData)
                .then((response) => {
                    this.closeShowModalLoading()
                    toast.success(response.data.messaggio);
                    setTimeout(() => {
                        this.$emit("appuntamento-spostato");
                        this.hide();
                    }, 1000);
                })
                .catch((e) => {
                    this.closeShowModalLoading();
                    toast.error(e?.response?.data?.messaggio)
                });
        },
        onConfermaAppuntamentoSingle() {
            this.$emit("conferma-single-appuntamento", this.spostaAppuntamentoJsonData, this.appuntamentoSelRow.index, this.indexRicettaSel)
            this.hide();
        }
    },
};
</script>

<style scoped>
/* I colori seguono il tema del cliente (public/css/<cliente>); i valori dopo la virgola sono di riserva. */
.ft-ga-riepilogo,
.ft-ga-sezione,
.ft-ga-confronto {
    --ft-accent: var(--bg-sidebar-item, #2ba7bd);
    --ft-border: #e3e8ee;
    --ft-muted: #6c757d;
    --ft-text: #323a46;
    --ft-bg-soft: #f7f9fb;
}

/* ---- riepilogo prestazione ---- */
.ft-ga-riepilogo {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 10px 12px;
    margin-bottom: 16px;
    background: var(--ft-bg-soft);
    border: 1px solid var(--ft-border);
    border-left: 4px solid var(--ft-accent);
    border-radius: 8px;
}

.ft-ga-riepilogo-icon {
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #fff;
    border: 1px solid var(--ft-border);
    color: var(--ft-accent);
}

.ft-ga-riepilogo-testo {
    flex: 1;
    min-width: 0;
}

.ft-ga-riepilogo-titolo {
    font-weight: 600;
    color: var(--ft-text);
}

.ft-ga-riepilogo-sub {
    font-size: 12px;
    color: var(--ft-muted);
}

.ft-ga-codice {
    margin-left: 6px;
    padding: 1px 6px;
    border-radius: 4px;
    font-family: var(--font-family-monospace, monospace);
    font-size: 11px;
    color: var(--ft-accent);
    background: #fff;
    border: 1px solid var(--ft-border);
}

/* ---- riferimento ricetta ---- */
.ft-ga-ricetta {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-left: 6px;
    padding: 1px 8px;
    border-radius: 4px;
    font-family: var(--font-family-monospace, monospace);
    font-size: 11px;
    font-weight: 600;
    color: var(--ft-text);
    background: #fff;
    border: 1px solid var(--ft-border);
    vertical-align: middle;
}

.ft-ga-ricetta-label {
    font-family: inherit;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: var(--ft-muted);
}

.ft-ga-ricetta-tipo {
    margin-left: 6px;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    vertical-align: middle;
    color: var(--bg-card-header-color-text, var(--ft-text));
    background: var(--bg-card-header-color, #eef1f4);
}

/* ---- riferimento agenda ---- */
.ft-ga-agenda {
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 11px;
    color: var(--ft-accent);
}

.ft-ga-agenda.is-vuota {
    font-style: italic;
    color: var(--ft-muted);
}

/* ---- pallini eseguiti / prenotati / ciclo (come nelle prestazioni SSN) ---- */
.ft-pallini {
    display: flex;
    align-items: flex-end;
    gap: 12px;
}

.ft-pallino-box {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ft-pallino-box label {
    margin-bottom: 2px;
    font-size: 11px;
    color: var(--ft-muted);
}

.ft-pallino {
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.ft-pallino-eseguiti {
    background: #218838;
}

.ft-pallino-prenotati {
    background: #ffc107;
}

.ft-pallino-ciclo {
    background: #00a3ff;
}

.ft-ga-step {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
}

.ft-ga-step-item {
    padding: 3px 10px;
    border-radius: 999px;
    color: var(--ft-muted);
    background: #fff;
    border: 1px solid var(--ft-border);
}

.ft-ga-step-item.is-active {
    color: #fff;
    background: var(--ft-accent);
    border-color: var(--ft-accent);
    font-weight: 600;
}

.ft-ga-step-sep {
    color: var(--ft-muted);
}

/* ---- sezioni ---- */
.ft-ga-sezione {
    height: 100%;
    padding: 10px 12px;
    background: #fff;
    border: 1px solid var(--ft-border);
    border-radius: 8px;
}

.ft-ga-sezione-titolo {
    margin-bottom: 8px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: var(--ft-muted);
}

.ft-ga-tabella {
    height: 300px;
    padding: 0 !important;
}

.ft-ga-tabella-alta {
    height: 450px;
}

.ft-ga-numero {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    border-radius: 50%;
    font-weight: 700;
    font-size: 11px;
    color: var(--ft-accent);
    background: var(--ft-bg-soft);
    border: 1px solid var(--ft-border);
}

.ft-ga-data {
    font-weight: 600;
    color: var(--ft-text);
}

.ft-ga-data small {
    margin-left: 4px;
    font-weight: 400;
    text-transform: capitalize;
    color: var(--ft-muted);
}

.ft-ga-ora {
    font-size: 12px;
    color: var(--ft-muted);
    font-variant-numeric: tabular-nums;
}

.ft-ga-stato {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--ft-muted);
}

/* ---- slot disponibili ---- */
.ft-ga-slots {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 8px;
    max-height: 230px;
    margin-top: 12px;
    overflow-y: auto;
}

.ft-ga-slot {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 110px;
    padding: 6px 12px;
    background: #fff;
    border: 1px solid var(--ft-border);
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.ft-ga-slot:hover {
    border-color: var(--ft-accent);
}

.ft-ga-slot:focus {
    outline: none;
}

.ft-ga-slot small {
    color: var(--ft-muted);
}

.ft-ga-slot-ora {
    font-weight: 600;
    color: var(--ft-text);
    font-variant-numeric: tabular-nums;
}

.ft-ga-slot.is-selected {
    border-color: var(--ft-accent);
    background: var(--ft-bg-soft);
    box-shadow: 0 0 0 2px var(--ft-accent);
}

/* ---- confronto attuale / nuovo ---- */
.ft-ga-confronto {
    display: flex;
    align-items: stretch;
    gap: 12px;
}

.ft-ga-box {
    flex: 1;
    padding: 10px 12px;
    background: var(--ft-bg-soft);
    border: 1px dashed var(--ft-border);
    border-radius: 8px;
}

.ft-ga-box-nuovo {
    background: #fff;
    border: 1px solid var(--ft-accent);
}

.ft-ga-box-titolo {
    margin-bottom: 4px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: var(--ft-muted);
}

.ft-ga-info {
    margin-top: 2px;
    font-size: 12px;
    color: var(--ft-text);
}

.ft-ga-freccia {
    align-self: center;
    font-size: 1.3rem;
    color: var(--ft-accent);
}

.ft-ga-vuoto {
    font-size: 12px;
    font-style: italic;
    color: var(--ft-muted);
}

/* riga dell'appuntamento spostato nel nuovo schema */
::v-deep .ft-ga-riga-spostata td {
    background-color: rgba(43, 167, 189, 0.12) !important;
    font-weight: 600;
}
</style>
